<header
  class="top-toolbar"
  [class.top-toolbar--scrolled]="scrolled"
  [class.top-toolbar--fixed]="hideOnScroll"
  [class.top-toolbar--hidden]="hideOnScroll && toolbarHidden"
  role="banner"
>
  <div class="top-toolbar__row">
    <div class="top-toolbar__start">
      <a
        [routerLink]="localizedPath('/')"
        class="top-toolbar__brand"
        i18n-aria-label="@@topToolbar.brandHomeAria"
        aria-label="arsnova.eu Startseite"
        (click)="onBrandLinkClick()"
      >
        <svg
          class="top-toolbar__brand-icon"
          viewBox="0 0 32 32"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id="toolbar-brand-eu-bg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="var(--app-eu-blue)" />
              <stop offset="100%" stop-color="var(--app-eu-blue-dark)" />
            </linearGradient>
          </defs>
          <rect width="32" height="32" rx="6" fill="url(#toolbar-brand-eu-bg)" />
          <rect x="2" y="2" width="28" height="28" rx="5" fill="var(--app-eu-blue)" />
          <path
            class="top-toolbar__brand-star"
            d="M23 18 L24.12 21.46 L27.76 21.45 L24.82 23.59 L25.94 27.05 L23 24.91 L20.06 27.05 L21.18 23.59 L18.24 21.45 L21.88 21.46 Z"
            fill="var(--app-eu-yellow)"
          />
        </svg>
        <span class="top-toolbar__brand-title">arsnova.eu</span>
      </a>
      @if (motdHeaderState.motdToolbarIcon()) {
        <button
          type="button"
          matIconButton
          class="top-toolbar__icon-btn top-toolbar__motd-btn"
          (click)="openMotdArchive()"
          [matTooltip]="motdToolbarArchiveTooltip()"
          [attr.aria-label]="motdArchiveAriaLabel()"
          [matBadge]="motdArchiveBadgeText()"
          [matBadgeHidden]="motdHeaderState.archiveUnreadCount() === 0"
          matBadgePosition="above after"
          matBadgeOverlap
        >
          <mat-icon aria-hidden="true">campaign</mat-icon>
        </button>
      }
    </div>

    <button
      type="button"
      matIconButton
      class="top-toolbar__menu-btn mobile-only"
      [attr.aria-expanded]="controlsMenuOpen() ? 'true' : 'false'"
      aria-controls="top-toolbar-mobile"
      i18n-aria-label="@@topToolbar.openMenuAria"
      aria-label="Einstellungen öffnen"
      (click)="toggleControlsMenu($event)"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <div class="top-toolbar__controls desktop-only">
      <div
        role="group"
        i18n-aria-label="@@topToolbar.choosePresetAria"
        aria-label="Preset auswählen"
        class="top-toolbar__toggles top-toolbar__toggles--preset"
      >
        <!-- Default zuerst: Hydration/Mobile sonst kurz Seriös sichtbar -->
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.preset() === 'spielerisch'"
          [attr.aria-pressed]="themePreset.preset() === 'spielerisch'"
          (click)="onPresetChange('spielerisch')"
        >
          <span class="top-toolbar__preset-option">
            <mat-icon class="top-toolbar__preset-icon-playful" aria-hidden="true"
              >celebration</mat-icon
            >
            <span i18n>Spielerisch</span>
          </span>
        </button>
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.preset() === 'serious'"
          [attr.aria-pressed]="themePreset.preset() === 'serious'"
          (click)="onPresetChange('serious')"
        >
          <span class="top-toolbar__preset-option">
            <mat-icon aria-hidden="true">work</mat-icon>
            <span i18n>Seriös</span>
          </span>
        </button>
      </div>

      <div
        role="group"
        i18n-aria-label="@@topToolbar.themeGroupAria"
        aria-label="Theme"
        class="top-toolbar__toggles"
      >
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.theme() === 'system'"
          [attr.aria-pressed]="themePreset.theme() === 'system'"
          i18n-aria-label="@@topToolbar.themeSystemAria"
          aria-label="System"
          (click)="onThemeChange('system')"
        >
          <mat-icon aria-hidden="true">contrast</mat-icon>
        </button>
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.theme() === 'dark'"
          [attr.aria-pressed]="themePreset.theme() === 'dark'"
          i18n-aria-label="@@topToolbar.themeDarkAria"
          aria-label="Dark"
          (click)="onThemeChange('dark')"
        >
          <mat-icon aria-hidden="true">dark_mode</mat-icon>
        </button>
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.theme() === 'light'"
          [attr.aria-pressed]="themePreset.theme() === 'light'"
          i18n-aria-label="@@topToolbar.themeLightAria"
          aria-label="Light"
          (click)="onThemeChange('light')"
        >
          <mat-icon aria-hidden="true">light_mode</mat-icon>
        </button>
      </div>

      <button
        type="button"
        matIconButton
        [matMenuTriggerFor]="langMenu"
        i18n-aria-label="@@topToolbar.languageAria"
        aria-label="Sprache"
        class="top-toolbar__icon-btn top-toolbar__lang-btn"
      >
        <mat-icon aria-hidden="true">language</mat-icon>
      </button>
      <mat-menu #langMenu="matMenu">
        @for (lang of supportedLanguages; track lang.code) {
          <button mat-menu-item (click)="setLanguage(lang.code)">
            <mat-icon matMenuItemIcon>language</mat-icon>
            {{ lang.label }}
          </button>
        }
      </mat-menu>
    </div>
  </div>

  @if (controlsMenuOpen()) {
    <div #mobileControls id="top-toolbar-mobile" class="top-toolbar__mobile">
      <div
        role="group"
        i18n-aria-label="@@topToolbar.themeGroupAria"
        aria-label="Theme"
        class="top-toolbar__toggles"
      >
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.theme() === 'system'"
          [attr.aria-pressed]="themePreset.theme() === 'system'"
          i18n-aria-label="@@topToolbar.themeSystemAria"
          aria-label="System"
          (click)="onThemeChange('system')"
        >
          <mat-icon aria-hidden="true">contrast</mat-icon>
        </button>
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.theme() === 'dark'"
          [attr.aria-pressed]="themePreset.theme() === 'dark'"
          i18n-aria-label="@@topToolbar.themeDarkAria"
          aria-label="Dark"
          (click)="onThemeChange('dark')"
        >
          <mat-icon aria-hidden="true">dark_mode</mat-icon>
        </button>
        <button
          type="button"
          class="top-toolbar__toggle"
          [class.top-toolbar__toggle--active]="themePreset.theme() === 'light'"
          [attr.aria-pressed]="themePreset.theme() === 'light'"
          i18n-aria-label="@@topToolbar.themeLightAria"
          aria-label="Light"
          (click)="onThemeChange('light')"
        >
          <mat-icon aria-hidden="true">light_mode</mat-icon>
        </button>
      </div>

      <div class="top-toolbar__mobile-lang">
        <button
          type="button"
          matIconButton
          [matMenuTriggerFor]="langMenuMobile"
          i18n-aria-label="@@topToolbar.languageAria"
          aria-label="Sprache"
          class="top-toolbar__icon-btn top-toolbar__lang-btn"
        >
          <mat-icon aria-hidden="true">language</mat-icon>
        </button>
      </div>
      <mat-menu #langMenuMobile="matMenu">
        @for (lang of supportedLanguages; track lang.code) {
          <button mat-menu-item (click)="setLanguage(lang.code)">
            <mat-icon matMenuItemIcon>language</mat-icon>
            {{ lang.label }}
          </button>
        }
      </mat-menu>
    </div>
  }

  @if (showSingleLocaleHint()) {
    <p class="top-toolbar__locale-hint" role="status">
      <mat-icon aria-hidden="true">info</mat-icon>
      <span i18n
        >In der Entwicklung wird nur Deutsch ausgeliefert. Für andere Sprachen:
        <code>npm run build:localize</code> und <code>serve:localize:api</code>.</span
      >
    </p>
  }
</header>
